export const url = import.meta.env.VITE_HASURA_URL
